import { Modal } from '@magnetic/modal'
import { Flex } from '@magnetic/flex'
import { Heading } from '@magnetic/heading'
import { Notification } from '@magnetic/notification'
import { Text } from '@magnetic/text'
import { Button } from '@magnetic/button'
import { Spinner } from '@magnetic/spinner'
import { Trash } from '@/lib/icons'

interface DeleteConfirmationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  applicationName: string
  isPending: boolean
}

export function DeleteConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  applicationName,
  isPending,
}: DeleteConfirmationModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
    >
      <Modal.Content>
        <Flex direction="vertical" gap="md" style={{ padding: 24 }}>
          <Heading size="section">Delete Application</Heading>
          <Text size="p3">
            Are you sure you want to delete <strong>{applicationName}</strong>?
          </Text>
          <Text size="p4" color="light">
            This will:
          </Text>
          <Flex direction="vertical" gap="xs">
            <Text size="p4" color="light">- Remove the ArgoCD Application CRD from the cluster</Text>
            <Text size="p4" color="light">- Delete all deployed Kubernetes resources</Text>
            <Text size="p4" color="light">- Remove the application record from the database</Text>
          </Flex>
          <Notification status="warning" title="This action cannot be undone">
            <Text size="p4">Please review the impact before deleting this application.</Text>
          </Notification>
          <Flex gap="sm" justify="flex-end">
            <Button
              kind="secondary"
              onClick={onClose}
              disabled={isPending}
            >
              Cancel
            </Button>
            <Button
              destructive
              onClick={onConfirm}
              disabled={isPending}
              icon={isPending ? <Spinner size="sm" aria-label="Deleting" /> : <Trash size={16} />}
            >
              {isPending ? 'Deleting...' : 'Delete Application'}
            </Button>
          </Flex>
        </Flex>
      </Modal.Content>
    </Modal>
  )
}
